// eslint-disable-next-line no-var
// eslint-disable-next-line @typescript-eslint/no-unused-vars
declare let featureIsInNode: boolean

  // https://stackoverflow.com/questions/4224606/how-to-check-whether-a-script-is-running-under-node-js
;(global as any).featureIsInNode =
  typeof process !== 'undefined' && process.release?.name === 'node'
